import {
  Navigate,
  Route,
  Routes as RouterDomRoutes,
  useParams
} from "react-router-dom"

import {
  LANDING,
  MISSING_EMAIL_VERIFICATION,
  NOT_FOUND,
  POST_EMAIL_VERIFICATION,
  PRODUCT,
  PRODUCT_CONFIGURATION,
  PROJECTS,
  REFERENCE_REDIRECT,
  REGISTER
} from "shared/constants/permalinks"
import { isNode } from "shared/lib/runtimeEnvironment"

import { BuildingReferenceRedirectPage } from "pages/building-reference-page/BuildingReferenceRedirectPage"
import { EmailVerificationPageConnector } from "pages/email-verification-page/EmailVerificationPageConnector"
import { PostEmailVerificationPageConnector } from "pages/email-verification-page/PostEmailVerificationPageConnector"
import { ProductConfigurationPage } from "pages/product-configuration-page/ProductConfigurationPage"
import { ProductPageConnector } from "pages/product-page/ProductPageConnector"
import { RegisterPage } from "pages/register-page/RegisterPage"
import PageWrapper from "widgets/layouts/PageWrapper"

import { LocaleRedirect } from "./LocaleRedirect"
import { LocaleVerifier } from "./LocaleVerifier"
import { ProjectIDVerifier } from "./ProjectIDVerifier"
import { ScrivitoRouteGuard } from "./ScrivitoRouteGuard"

export function Routes() {
  // disable routing while prerendering
  if (isNode()) {
    return <PageWrapper />
  }

  return (
    <RouterDomRoutes>
      <Route path="*" element={<LocaleRedirect />} />
      <Route path="/:locale" element={<LocaleVerifier />}>
        <Route path="*" element={<ProjectIDVerifier />}>
          <Route
            path={MISSING_EMAIL_VERIFICATION}
            element={<EmailVerificationPageConnector />}
          />
          <Route
            path={POST_EMAIL_VERIFICATION}
            element={<PostEmailVerificationPageConnector />}
          />
          <Route
            path={`${PRODUCT_CONFIGURATION}/:variantKey`}
            element={<ProductConfigurationPage />}
          />
          <Route
            path={`${REFERENCE_REDIRECT}/:referenceID`}
            element={<BuildingReferenceRedirectPage />}
          />
          <Route
            path={`${PRODUCT}/:variantKey`}
            element={<ProductPageConnector />}
          />
          <Route
            path={`${PROJECTS}/:projectID`}
            element={<ProjectDetailsRedirect />}
          />
          <Route
            path={`share/${PROJECTS}/:shareID`}
            element={<SharedProjectDetailsRedirect />}
          />
          <Route path={REGISTER} element={<RegisterPage />} />
          <Route path="welcome" element={<PageWrapper />} />
          <Route path="" element={<Navigate to={LANDING} replace />} />
          <Route
            path="*"
            element={
              <ScrivitoRouteGuard>
                <PageWrapper />
              </ScrivitoRouteGuard>
            }
          />
        </Route>
      </Route>
    </RouterDomRoutes>
  )
}

function ProjectDetailsRedirect() {
  const { locale, projectID } = useParams()

  if (!locale || !projectID) {
    return <Navigate to={NOT_FOUND} />
  }

  return (
    <Navigate
      to={`/${locale}/project-details?project_id=${projectID as string}`}
      replace
    />
  )
}

function SharedProjectDetailsRedirect() {
  const { locale, shareID } = useParams()

  if (!locale || !shareID) {
    return <Navigate to={NOT_FOUND} />
  }

  return (
    <Navigate
      to={`/${locale}/shared-project-details?shared_project_id=${
        shareID as string
      }`}
      replace
    />
  )
}
